<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4Cuc3M/tc-custom/9781476725307.jpg?1730518493241" alt="This image is the cover for the book Monsoon Summer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Monsoon Summer
      </h1>
      <p class="bookDescription body article font2">
        <b>By the award-winning author of <i>East of the Sun, </i>“a powerful and memorable novel” (<i>Publishers Weekly) </i>about the forbidden love between a young Indian doctor and an English midwife.</b><br/><br/>Oxfordshire, 1947. Kit Smallwood, hiding a painful secret and exhausted from nursing soldiers during the Second World War, escapes to Wickam Farm where her friend is setting up a charity sending midwives to the Moonstone Home in South India.<br/><br/>Then Kit meets Anto, an Indian doctor finishing his medical training at Oxford. But Kit’s light-skinned mother is in fact Anglo-Indian with secrets of her own, and Anto is everything she does not want for her daughter.<br/><br/>Despite the threat of estrangement, Kit is excited for the future, hungry for adventure, and deeply in love. She and Anto secretly marry and set off for South India—where Kit plans to run the maternity hospital she’s helped from afar.<br/><br/>But Kit’s life in India does not turn out as she imagined. Anto’s large, traditional family wanted him to marry an Indian bride and find it hard to accept Kit. As their relationship begins to fray, Kit’s job becomes fraught with tension as they both face a newly independent India, where riots have left millions dead and there is deep-rooted suspicion of the English. In a rapidly changing world, Kit’s naiveté is to land her in a frightening and dangerous situation...<br/><br/>Based on true accounts of European midwives in India, <i>Monsoon Summer</i> is a powerful story of secrets, the nature of home, the comforts and frustrations of family, and how far we’ll go to be with those we love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julia Gregson
      </h2>
      
      <p class="authorDescription body article">Julia Gregson has worked as a journalist and foreign correspondent in the UK, Australia, and the&#160;US.&#160;She is the author of <I>East of the Sun</I>, which was a major bestseller in the UK and won&#160;the Romantic Novel of the Year Prize and the Le Prince Maurice&#160;Prize there, and <I>Monsoon Summer</I>.&#160;Her short stories have been published in collections and magazines and read on the radio.&#160;She lives in Monmouthshire, Wales.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atria
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38386ce4